import React, { FC, useEffect, useState } from 'react';
import styles from './DIRPage.module.scss';
import { useAppSelector } from '../../services/store/hooks';
import { IDirData, StatisitcsInterpretationFromDIR } from '../../utils/GlobalTypes';
import { DataTableDIR, StatisticsDataTableDIR } from '../../components/AppLogic';
import { useTheme } from '@mui/material/styles';
import { bgColorMain } from '../../utils/ThemeConstants';

interface ITables {
  dataToShow: IDirData | null;
}

const Tables: FC<ITables> = ({ dataToShow }) => {
  const theme = useTheme();

  const { currentInterpretation, currentFileInterpretations } = useAppSelector(
    (state) => state.dirPageReducer,
  );
  const [interpretations, setInterpretations] = useState<StatisitcsInterpretationFromDIR[] | null>(
    null,
  );

  useEffect(() => {
    if (currentFileInterpretations && currentFileInterpretations.length)
      setInterpretations(currentFileInterpretations);
    else if (currentInterpretation) setInterpretations([currentInterpretation]);
    else setInterpretations(null);
  }, [currentInterpretation, currentFileInterpretations]);

  return (
    <div className={styles.tables} style={{ backgroundColor: bgColorMain(theme.palette.mode) }}>
      <StatisticsDataTableDIR currentFileInterpretations={interpretations} />
      <DataTableDIR data={dataToShow} />
    </div>
  );
};

export default Tables;
